export default "__VITE_ASSET__CgBjH1ak__"